import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const HeaderAdv1 = () => {
  return <header className="bg-white" data-id="element-599">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-600"></div>
      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-601">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-602">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-603">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-604">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>
        <div className="flex justify-start mb-3" data-id="element-605">
          <div className="text-xs text-gray-400 font-sans" data-id="element-606">Advertorial 1</div>
        </div>
        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-607">
          <div className="text-left" data-id="element-608">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-609">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-610">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>
      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-611">
        <div className="max-w-4xl mx-auto" data-id="element-612">
          <div className="flex items-center text-xs text-gray-500 mb-4 border-b border-gray-200 pb-2" data-id="element-613">
            <div className="flex items-center mr-4" data-id="element-614">
              <BookOpenIcon className="h-3 w-3 mr-1" data-id="element-615" />
              <span data-id="element-616">Health Investigation Series</span>
            </div>
            <div className="flex items-center" data-id="element-617">
              <CalendarIcon className="h-3 w-3 mr-1" data-id="element-618" />
              <span data-id="element-619">
                Updated:{' '}
                {(() => {
                const yesterday = new Date();
                yesterday.setDate(yesterday.getDate() - 1);
                return yesterday.toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                });
              })()}
              </span>
            </div>
          </div>
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-620">
            INVESTIGATIVE REPORT
          </div>
          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-621">
            73-Year-Old Corning Engineer Exposes Why All Grounding Sheets Fail —
            Then Builds Ones That Don't
          </h1>
          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-622">
            How submarine cable technology and $388,716 in retirement savings
            led to the only grounding sheets that still work after 1,000 washes
          </p>
          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-623">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-624">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/w6iLitytwoh7neSkFUSQgw/IMG7.png" alt="Tom Davidson" className="w-full h-full object-cover" data-id="element-625" />
            </div>
            <div className="flex-1" data-id="element-626">
              <div className="flex items-center" data-id="element-627">
                <div className="font-medium text-gray-900 text-lg" data-id="element-628">
                  By Tom Davidson
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-629">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-630" />
                  <span className="text-xs ml-1 font-medium" data-id="element-631">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-632">
                Retired Electrical Engineer, Corning Inc. | As told to
                Traditional Medicine Publications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-633">
                <div className="flex items-center mr-4" data-id="element-634">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-635" />
                  <span data-id="element-636">9 min read</span>
                </div>
                <div className="flex items-center" data-id="element-637">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-638" />
                  <span data-id="element-639">18,342 views</span>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-640">
            <div className="mb-1 flex items-center" data-id="element-641">
              <span className="font-medium mr-2" data-id="element-642">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-643">
              <span className="font-medium mr-2" data-id="element-644">Published:</span>
              December 2024
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderAdv1;